import { env } from "@frontend/configs/env.config";

/**
 * Frontend branding. The colours here are the BUILD-time `VITE_BRAND_*_COLOR`;
 * the container's own env overrides them at runtime (`/brand-colors.json`,
 * see `contexts/BrandingContext.tsx`). The app name and logo here are
 * first-paint fallbacks: the live ones come from the backend env.
 */
export const brand = {
	appName: env.VITE_APP_NAME,
	shortName: env.VITE_APP_SHORT_NAME ?? env.VITE_APP_NAME,
	tagline: env.VITE_APP_TAGLINE ?? "See it on yourself",
	garmentNoun: env.VITE_GARMENT_NOUN ?? "garment",
	primaryColor: env.VITE_BRAND_PRIMARY_COLOR ?? null,
	secondaryColor: env.VITE_BRAND_SECONDARY_COLOR ?? null,
	logoUrl: env.VITE_BRAND_LOGO_URL ?? null,
} as const;
